import { useMemo, useState } from "react";
import { galleryItems } from "@/mocks/home";

const filters = ["全部", "写真", "街拍", "海边", "胶片", "季节"];

export default function GalleryGrid() {
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    if (active === "全部") return galleryItems;
    return galleryItems.filter(
      (item) => item.tag === active || item.title.includes(active),
    );
  }, [active]);

  return (
    <section id="gallery" className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
        <div>
          <span className="text-primary-600 text-xs font-medium tracking-[0.24em] uppercase">
            Featured Gallery
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
            精选套图 · 封面即入口
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2 max-w-2xl">
            从数百组作品中挑出的人气套图，以封面直达合集，收藏你偏爱的风格。
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`px-4 h-9 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {list.map((item) => (
          <a
            key={item.id}
            href="#gallery"
            className="group bg-background-50 border border-background-200/80 rounded-lg overflow-hidden flex flex-col transition-colors hover:border-primary-300 cursor-pointer"
          >
            <div className="relative w-full aspect-[4/5] overflow-hidden">
              <img
                src={item.cover}
                alt={`小蜜桃写真套图 ${item.title}`}
                title={`${item.title} - 美丽的小蜜桃写真套图`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
              <span className="absolute top-3 left-3 text-[11px] font-medium px-2.5 py-1 rounded-full bg-background-50/90 text-primary-700 backdrop-blur">
                {item.tag}
              </span>
              <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 text-[11px] font-medium px-2.5 py-1 rounded-full bg-foreground-950/60 text-white backdrop-blur">
                <i className="ri-image-2-line" />
                {item.meta}
              </span>
            </div>
            <div className="p-4 flex items-center justify-between gap-3">
              <span className="flex flex-col min-w-0">
                <span className="font-heading font-bold text-base text-foreground-950 truncate">
                  {item.title}
                </span>
                <span className="text-xs text-foreground-500 mt-1">
                  高清原图 · 支持在线收藏
                </span>
              </span>
              <span className="w-9 h-9 shrink-0 rounded-full bg-background-100 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 flex items-center justify-center transition-colors">
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}